export default __webpack_public_path__ + "static/spine/owly2.png";